module.exports = __webpack_public_path__ + "mainassets/img/arrow-right-bright.f12c0a3a.svg";